import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.style.height = getComputedStyle(this.element).width;
  }
}
